import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "quickpay-pitch__text" }
const _hoisted_2 = { class: "quickpay-pitch__title typographies-display-brand-small" }
const _hoisted_3 = { class: "quickpay-pitch__description typographies-paragraph-medium-regular" }
const _hoisted_4 = { class: "quickpay-pitch__preview" }

import { inject } from 'vue';
import { Translator } from 'js/shims-vue';
import Card from 'vcomponents/common/card/Card.vue';
import TranslationText from 'vcomponents/common/TranslationText.vue';
import VideoPreview from 'vcomponents/common/VideoPreview/VideoPreview.vue';
import { type TranslationPart, useTranslationLinkParser } from 'composables/useTranslationLinkParser';

const illustrationSrc = '/ressources/logged/img/icon/svg/quickpay-pitch-illustration.svg';
const videoUrl = 'https://vimeo.com/1174824354/0c1d7a551e';


export default /*@__PURE__*/_defineComponent({
  __name: 'QuickpaySettingsPitch',
  setup(__props) {

const $t = inject('$t') as Translator;

const { parseTranslation } = useTranslationLinkParser();

const translations: Record<string, string> = {
    title: $t.__('quickpay.settings.pitch.title'),
};

const descriptionParts: TranslationPart[] = parseTranslation(
    $t.__('quickpay.settings.pitch.description'),
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Card, { class: "quickpay-pitch" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("p", _hoisted_2, _toDisplayString(translations.title), 1 /* TEXT */),
        _createElementVNode("p", _hoisted_3, [
          _createVNode(TranslationText, { parts: _unref(descriptionParts) }, null, 8 /* PROPS */, ["parts"])
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(VideoPreview, {
          thumbnailSrc: illustrationSrc,
          videoUrl: videoUrl
        })
      ])
    ]),
    _: 1 /* STABLE */
  }))
}
}

})